import { PeriodSchedule } from "./PeriodSchedule";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);
export class PeriodSchedules {
    _periods = [];
    constructor(periods = []) {
        this.periods = periods;
    }
    updateModelValues() {
        this._periods.forEach((bm) => bm.updateModelValues());
    }
    updateJsValues() {
        this._periods.forEach((bm) => bm.updateJsValues());
    }
    get all() {
        return this._periods;
    }
    get hasCustomPeriods() {
        return this._periods.some((period) => period.type === "custom");
    }
    get allCustomPeriods() {
        return this._periods.filter((period) => period.type === "custom");
    }
    get periods() {
        return this._periods;
    }
    set periods(value) {
        const periods = [];
        this.reset();
        value.forEach((period) => {
            if (!(period instanceof PeriodSchedule)) {
                periods.push(new PeriodSchedule(period));
            }
            else {
                periods.push(period);
            }
        });
        this._periods = periods;
    }
    reset() {
        this._periods = [];
    }
    // proxy forEach method that is a proxy to the periods array
    forEach(callbackfn) {
        this._periods.forEach(callbackfn);
    }
    addPeriod(period) {
        this.periods.push(period);
    }
    removePeriod(index) {
        this.periods.splice(index, 1);
    }
    atIndex(index) {
        // index must must be 0 or greater,
        // if it is not, return the first period
        if (index < 0) {
            return this.firstPeriod;
        }
        return this.periods[index];
    }
    get length() {
        return this.periods.length;
    }
    get lastPeriod() {
        return this.periods[this.length - 1];
    }
    get firstPeriod() {
        return this.periods[0];
    }
    get json() {
        return this._periods.map((r) => r.json);
    }
    toJSON() {
        return this.json;
    }
}
